import {
  enumInboundTollingAgreementSortOption,
  InboundTollingAgreementSortOption,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { inboundTollingAgreementsQueryAtom } from '../_graphql/queryInboundTollingAgreements';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('q');
export const $selectedProcessingType = atomFromQueryString.string('type');
export const $selectedCustomerAccount = atomFromQueryString.string('customer');
export const $showInactive = atomFromQueryString.boolean('inactive', false);
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

export const $currentSorting = atom<InboundTollingAgreementSortOption[]>([
  enumInboundTollingAgreementSortOption.CreatedAtDesc,
]);

export const $remoteInboundTollingAgreements =
  inboundTollingAgreementsQueryAtom((get) => {
    const searchTerm = get($searchTerm);
    const selectedProcessingType = get($selectedProcessingType);
    const selectedCustomerAccount = get($selectedCustomerAccount);
    const showInactive = get($showInactive);
    const limit = get($limit);
    const offset = get($offset);
    const sorting = get($currentSorting);

    return {
      variables: {
        searchTerm: searchTerm || undefined,
        processingTypeIds:
          selectedProcessingType && selectedProcessingType !== 'all'
            ? [selectedProcessingType]
            : undefined,
        customerAccountIds:
          selectedCustomerAccount && selectedCustomerAccount !== 'all'
            ? [selectedCustomerAccount]
            : undefined,
        isActive: showInactive ? undefined : true,
        limit,
        offset,
        sorting,
      },
    };
  });
